"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const ClrField_1 = __importDefault(require("components/QuickenControls/ClrField"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const styles_1 = require("containers/NewReports/styles");
const utils_1 = require("./utils");
const TransactionRow = ({ txn, displayTxn, displayRowId, rowKey, txnIndent, amount, isSelected, checkboxSize, categoryId, getAccountName, onToggleSelect, tagsById, classes, isPayeeBreakdown, getCategoryName, }) => {
    var _a, _b, _c, _d, _e, _f;
    const renderedTxn = displayTxn || txn;
    const txnId = displayRowId || (0, utils_1.getTxnField)(renderedTxn, 'id') || (0, utils_1.getTxnField)(txn, 'id') || '';
    const rowId = displayRowId || txnId;
    const postedOn = (0, utils_1.getTxnField)(renderedTxn, 'postedOn');
    const accountId = (0, utils_1.getTxnField)(renderedTxn, 'accountId');
    const payee = (0, utils_1.getTxnField)(renderedTxn, 'payee') || '';
    const categoryDisplay = isPayeeBreakdown
        ? (0, utils_1.getTxnCategoryDisplay)(renderedTxn, getCategoryName)
        : undefined;
    const memo = (0, utils_1.getTxnMemoForRow)(renderedTxn, categoryId);
    const num = (_f = (_d = (_c = (_b = (_a = (0, utils_1.getTxnField)(renderedTxn, 'checkNumber')) !== null && _a !== void 0 ? _a : (0, utils_1.getTxnField)(renderedTxn, 'checkNum')) !== null && _b !== void 0 ? _b : (0, utils_1.getTxnField)(renderedTxn, 'num')) !== null && _c !== void 0 ? _c : (0, utils_1.getTxnField)(renderedTxn, 'number')) !== null && _d !== void 0 ? _d : (_e = (0, utils_1.getTxnField)(renderedTxn, 'check')) === null || _e === void 0 ? void 0 : _e.number) !== null && _f !== void 0 ? _f : '';
    const clr = ((0, utils_1.getTxnField)(renderedTxn, 'state') || '').toString();
    const tagNames = (0, utils_1.getTagNames)((0, utils_1.getTxnTagsValue)(renderedTxn, categoryId), tagsById);
    return (<TableRow_1.default key={`${rowKey}-txn-${txnId}`} hover className={classes.transactionRow} sx={{ cursor: 'default' }}>
      <styles_1.StickyTableCellLeft sx={{ p: 0 }}>
        <Box_1.default display="flex" alignItems="center" justifyContent="flex-start" pl={`${txnIndent}px`}>
          <Box_1.default className={classes.checkboxCompactWrapper}>
            <QCheckbox_1.default size={checkboxSize} checked={isSelected} onClick={(e) => {
            e.stopPropagation();
            onToggleSelect(txn);
        }}/>
          </Box_1.default>
          <Typography_1.default className={classes.rowCellContent} sx={{ ml: 1 }}>
            {postedOn ? luxon_1.DateTime.fromISO(postedOn).toFormat('MM/dd/yyyy') : ''}
          </Typography_1.default>
        </Box_1.default>
      </styles_1.StickyTableCellLeft>
      <TableCell_1.default className={classes.rowCell}>
        <QTip_1.default wrapOnly title={getAccountName(accountId)} wrapId={`${rowId}-account`}>
          <span className={classes.rowCellContent}>{getAccountName(accountId)}</span>
        </QTip_1.default>
      </TableCell_1.default>
      <TableCell_1.default className={classes.rowCell}>
        <QTip_1.default wrapOnly title={String(num)} wrapId={`${rowId}-num`}>
          <span className={classes.rowCellContent}>{num}</span>
        </QTip_1.default>
      </TableCell_1.default>
      <TableCell_1.default className={classes.rowCell}>
        {isPayeeBreakdown ? (<QTip_1.default wrapOnly title={categoryDisplay} wrapId={`${rowId}-category`}>
            <span className={classes.rowCellContent}>{categoryDisplay}</span>
          </QTip_1.default>) : (<QTip_1.default wrapOnly title={payee} wrapId={`${rowId}-payee`}>
            <span className={classes.rowCellContent}>{payee}</span>
          </QTip_1.default>)}
      </TableCell_1.default>
      <TableCell_1.default className={classes.rowCell}>
        <QTip_1.default wrapOnly title={memo} wrapId={`${rowId}-memo`}>
          <span className={classes.rowCellContent}>{memo}</span>
        </QTip_1.default>
      </TableCell_1.default>
      <TableCell_1.default className={classes.rowCell}>
        <QTip_1.default wrapOnly title={tagNames} wrapId={`${rowId}-tags`}>
          <span className={classes.rowCellContent}>{tagNames}</span>
        </QTip_1.default>
      </TableCell_1.default>
      <TableCell_1.default align="center" className={classes.rowCell}>
        <Box_1.default className={classes.clrCellContent}>
          <ClrField_1.default value={clr} autoFocus={false} editable={false} includeEmpty={false}/>
        </Box_1.default>
      </TableCell_1.default>
      <styles_1.StickyTableCellRight align="center">{amount.toFixed(2)}</styles_1.StickyTableCellRight>
    </TableRow_1.default>);
};
exports.default = react_1.default.memo(TransactionRow);
